.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.92);
  color: #fff;
  font-family: 'Consolas', 'Menlo', 'Monaco', monospace;
  font-size: 12px;
  line-height: 1.5;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.overlay.visible {
  opacity: 1;
  pointer-events: auto;
}

/* ── Header ── */
.header {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
  gap: 8px;
}

.headerTitle {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #3A9749;
  flex: 1;
}

.commitHash {
  font-size: 10px;
  color: #d1d1d1;
  white-space: nowrap;
}

.keyHint {
  font-size: 10px;
  color: #d1d1d1;
  white-space: nowrap;
}

/* ── Body: stats (top) + log strip (bottom) ── */
.body {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ── Live Stats panel — full width, top, scrollable ── */
.statsPanel {
  flex: 1;
  min-height: 0;
  padding: 6px 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #53709B transparent;
}

.statsPanel::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.statsPanel::-webkit-scrollbar-track {
  background: transparent;
}

.statsPanel::-webkit-scrollbar-thumb {
  background: #53709B;
  border-radius: 2px;
}

.statsGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px 12px;
}

.statRow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
}

.statLabel {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #d1d1d1;
  flex-shrink: 0;
  white-space: nowrap;
}

.statLabel::after {
  content: ':';
}

.statValue {
  color: #fff;
  font-size: 11px;
  word-break: break-all;
  min-width: 0;
}

/* ── Log panel — fixed-height strip at bottom ── */
.logPanel {
  height: 100px;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  scrollbar-width: thin;
  scrollbar-color: #53709B transparent;
}

.logPanel::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.logPanel::-webkit-scrollbar-track {
  background: transparent;
}

.logPanel::-webkit-scrollbar-thumb {
  background: #53709B;
  border-radius: 2px;
}

.logLine {
  white-space: pre-wrap;
  word-break: break-all;
  color: #BABABA;
  user-select: text;
}

.logLine.error {
  color: #B83939;
}

.logLine.highlight {
  color: #fff;
}


